// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const StripeClui: MarkdocTagRegistration = {
  tag: 'stripe-clui',
  component: 'StripeClui',
};
